import React from 'react'
import { ContentRenderer } from '../CardPage/components'
import {
  TEST_VIDEO_BLOCKS,
  REAL_KINESCOPE_VIDEOS,
} from '../../constants/testVideoData'
import { useTelegramWebApp } from '../../hooks/useTelegramWebApp'
import './TestVideoPage.css'

const TestVideoPage: React.FC = () => {
  const { platform, isAndroid, webApp } = useTelegramWebApp()

  return (
    <div className="test-video-page">
      <div className="test-info">
        <h1>Тест видеопроигрывателя</h1>
        <div className="platform-info">
          <p>
            <strong>Платформа:</strong> {platform}
          </p>
          <p>
            <strong>Android:</strong> {isAndroid ? 'Да' : 'Нет'}
          </p>
          <p>
            <strong>WebApp версия:</strong> {webApp?.version || 'неизвестно'}
          </p>
        </div>
        <div className="test-description">
          <p>
            На этой странице можно протестировать работу кастомного
            видеопроигрывателя.
          </p>
          <p>
            📱 <strong>Видео Kinescope</strong> показывают кнопку полноэкранного
            режима (иконка с четырьмя стрелками)
          </p>
          <p>
            🎬 <strong>YouTube видео</strong> отображаются как обычный iframe
            без дополнительных кнопок
          </p>
          <p>
            ✨ Полноэкранный режим блокирует скролл страницы и учитывает Safe
            Area
          </p>
        </div>
      </div>

      <div className="test-content">
        <h2>Тестовые видео</h2>
        <ContentRenderer content={TEST_VIDEO_BLOCKS} />

        <h2>Реальное Kinescope видео</h2>
        <ContentRenderer content={REAL_KINESCOPE_VIDEOS} />
      </div>
    </div>
  )
}

export default TestVideoPage
